@if (formattedDisplay$ | async; as formattedDisplay) {
  @if (display$ | async; as display) {
    @if (display.style === 'text') {
      @if (formattedDisplay.label) {
        <strong>{{ formattedDisplay.label }}: </strong>
      }
      @if (formattedDisplay.value) {
        <span>{{ formattedDisplay.value }}</span>
      }
    } @else {
      {{ formattedDisplay.rendered }}
    }
  }
}
